var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-card',{staticClass:"q-pa-xl bg-grey-2 text-center"},[_c('div',{staticClass:"text-h1"},[_vm._v("404")]),_vm._v(" "),_c('div',{staticClass:"text-h4"},[_vm._v("Tu nie je nič :(")])])
}
var staticRenderFns = []

export { render, staticRenderFns }